import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {PaymentDTO} from '../models/payment/PaymentDTO';
import {PaymentAuditDTO} from '../models/PaymentAuditDTO';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/xml'
  })
};

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  private paymentsUrl = environment.baseClmUrl + '/payment';

  constructor(private httpClient: HttpClient) {
  }

  getListOfPayments(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<PaymentDTO>> {
    return this.httpClient.post<PagedResponseDTO<PaymentDTO>>(this.paymentsUrl + '/filter', pagedRequestDTO);
  }

  getListOfPaymentsBy(caseId: number): Observable<PaymentDTO[]> {
    return this.httpClient.get<PaymentDTO[]>(`${this.paymentsUrl}/byCaseId?caseId=${caseId}`);
  }

  getListOfPaymentsByInsuredPersonId(personId: number): Observable<PaymentDTO[]> {
    return this.httpClient.get<PaymentDTO[]>(`${this.paymentsUrl}/byPersonId?personId=${personId}`);
  }

  savePayment(paymentDTO: any): Observable<PaymentDTO> {
    return this.httpClient.post<PaymentDTO>(this.paymentsUrl, paymentDTO);
  }

  getPaymentAuditByCaseId(caseId: number, providerId: number): Observable<PaymentAuditDTO[]> {
    return this.httpClient.get<PaymentAuditDTO[]>(`${this.paymentsUrl}/audit?caseId=${caseId}&providerId=${providerId}`);
  }

  getPayment(paymentId: number): Observable<PaymentDTO> {
    return this.httpClient.get<PaymentDTO>(`${this.paymentsUrl}/${paymentId}`);
  }

}
